module.exports = __webpack_public_path__ + "img/issue-icon8.6c6e9f0.png";